"use client";
import { Row, Stack } from "react-bootstrap";
import { IoLocationOutline } from "react-icons/io5";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { BiSolidHide } from "react-icons/bi";
import IconButton from "../components/IconButton/IconButton";
import ButtonDropdownMenu, {
  ButtonDropdownMenuOption,
} from "../components/ButtonDropDownMenu/ButtonDropDownMenu";
import toast from "react-hot-toast";

export function CheckIcon({ backgroundColor }: { backgroundColor?: string }) {
  return (
    <div
      style={{
        margin: "auto",
        width: "0.65rem",
        height: "0.65rem",
        backgroundColor: backgroundColor,
        borderRadius: "50%",
        border: "1px solid #ccc",
      }}
    ></div>
  );
}

type IconButtonGroupProps = {
  toast: typeof toast;
  container_offsetLeft: number;
  calendarOptions: ButtonDropdownMenuOption[];
  selectedCalendars: number[];
  setSelectedCalendars: (t: number[]) => void;
  onPlaceClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onCalendarClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function IconButtonGroup({
  container_offsetLeft,
  calendarOptions,
  selectedCalendars,
  setSelectedCalendars,
  onPlaceClick,
  onCalendarClick,
}: IconButtonGroupProps) {

const onShowHideTriggerClick = ()=>{
    if(!calendarOptions || calendarOptions.length === 0){
      toast.error(`No calendars yet!`);
      return;
    }
  }
  return (
    <>
      <Row>
        <div
          style={{
            position: "absolute",
            right: `${container_offsetLeft}px`,
            // bottom: "10px",
            // fontSize: "12px",
            marginBottom: "8px",
            width: "auto",
          }}
        >
          <Stack direction="horizontal" gap={2} style={{ float: "right" }}>
            <IconButton
              title="Place"
              buttonContent={<IoLocationOutline />}
              onClickFunc={onPlaceClick ?? (() => {})}
            />
            <IconButton
              title="Calendar"
              buttonContent={<MdOutlineCalendarMonth />}
              onClickFunc={onCalendarClick ?? (() => {})}              
            />
            <ButtonDropdownMenu
              title="Show/Hide"
              buttonContent={
                <>
                  <BiSolidHide />
                </>
              }
              options={calendarOptions}
              value={selectedCalendars}
              setValueFunc={setSelectedCalendars}
              triggerFunc={onShowHideTriggerClick}
            />
          </Stack>
        </div>
      </Row>
    </>
  );
}
